import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { retryOperation, cancelOperation } from '../api';
import { useToast } from '../../../common/hooks';

export const useOperationActions = () => {
    const queryClient = useQueryClient();
    const { success: successToast, error: errorToast } = useToast();
    const [busyId, setBusyId] = useState(null);

    const invalidate = () => {
        queryClient.invalidateQueries({ queryKey: ['operations'] });
    };

    const retry = useMutation({
        mutationFn: async (id) => retryOperation(id),
        onSuccess: () => {
            successToast('عملیات برای اجرای مجدد برنامه‌ریزی شد');
            invalidate();
        },
        onError: (err) => {
            errorToast(err?.response?.data?.message || 'خطا در اجرای مجدد عملیات');
        },
    });

    const cancel = useMutation({
        mutationFn: async (id) => cancelOperation(id),
        onSuccess: () => {
            successToast('عملیات لغو شد');
            invalidate();
        },
        onError: (err) => {
            errorToast(err?.response?.data?.message || 'خطا در لغو عملیات');
        },
    });

    const run = (id, action) => {
        setBusyId(id);
        const mutation = action === 'retry' ? retry : cancel;
        mutation.mutateAsync(id).finally(() => setBusyId(null));
    };

    return { retry: run, cancel: run, busyId };
};

export default useOperationActions;